export const CONTENT_BROWSER_TYPE = 'content-browser';
export const SUBJECT_BROWSER_TYPE = 'subject-browser';
export const TOPIC_BROWSER_TYPE = 'topic-browser';
export const UNIT_BROWSER_TYPE = 'unit-browser';
export const YEAR_BROWSER_TYPE = 'year-browser';
export const CURRICULUM_BROWSER_TYPE = 'curriculum-browser';

export type BrowserType =
  | typeof CONTENT_BROWSER_TYPE
  | typeof SUBJECT_BROWSER_TYPE
  | typeof TOPIC_BROWSER_TYPE
  | typeof UNIT_BROWSER_TYPE
  | typeof YEAR_BROWSER_TYPE
  | typeof CURRICULUM_BROWSER_TYPE;
